import { Button } from '@/components/ui/button';
import { Calendar, Share2 } from 'lucide-react';
import { EventAdminActions } from '@/components/events/EventAdminActions';

interface BannerProps {
  banner: string | null;
  title: string;
  isAdmin: boolean;
  communityId?: string | null;
  eventId: string;
  onShare: () => void;
}

export function Banner({ banner, title, isAdmin, communityId, eventId, onShare }: BannerProps) {
  return (
    <div className="space-y-3 mb-6 md:mb-8">
      <div className="w-full aspect-[16/9] bg-muted rounded-xl overflow-hidden relative">
        {banner ? (
          <img src={banner} alt={title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-muted text-muted-foreground/40">
            <Calendar className="h-16 w-16" />
          </div>
        )}
        <div className="absolute top-3 right-3 sm:top-4 sm:right-4">
          <Button
            size="icon"
            variant="secondary"
            className="h-9 w-9 rounded-full bg-background/90 shadow-md backdrop-blur-sm hover:bg-background"
            onClick={onShare}
          >
            <Share2 className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {isAdmin && communityId ? (
        <EventAdminActions communityId={communityId} eventId={eventId} variant="banner" />
      ) : null}
    </div>
  );
}
